export default __webpack_public_path__ + "static/media/hero.411b52da.jpg";